import axios from 'axios';

export default class ApiService {

    get (endpoint) {
        return new Promise((resolve, reject) => {
            axios.get('https://gemeindeplaner.at/api' + endpoint +
                '?api_token=GW4yg7vxT9aNTVoOU677qWZRfaVqZ4FRe3gG3FRHunUc8ub5gLHmUKDc1TeE').
                then((response) => {
                    if (response.status === 200) {
                        resolve(response.data);
                    }
                    else {
                        reject('Something went wrong');
                    }
                });
        });
    }
}